import type { ValueEvent } from '@adornis/base/utilTypes.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { WindowSizeController } from '@adornis/chemistry/controllers/window-size-controller.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { permissionGuard } from '@adornis/user-forms/permission-guard.js';
import { ANY_CONTEXT } from '@adornis/users/db/a-roles.js';
import { CampusArea } from '@chancenwerk/campus-learning-content/entities/CampusSection.js';
import { ChancenPermission } from '@chancenwerk/db/permissions.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { guard } from 'lit/directives/guard.js';

@customElement('campus-page-lounge-external')
export class CampusPageLoungeExternal extends ChemistryLitElement {
  @state() private readonly _userCheckedSubjects = new RXController<string[]>(this, []);
  @state() private readonly _userSearchText = new RXController<string>(this, '');
  @state() private readonly _updateList = 0;
  @state() size = new WindowSizeController(this);

  override render() {
    return permissionGuard(ChancenPermission.campus.READ_LOUNGE_EXTERNAL, () => this._content(), {
      forbiddenTemplate: html` <campus-page-no-permission></campus-page-no-permission> `,
      context: ANY_CONTEXT,
    });
  }

  private _content() {
    return html`
      <cr-flex padding="${this.size.mobile ? 'md' : 'lg'}" space="lg">
        <campus-component-eventlist
          ?editingMode=${false}
          .area=${CampusArea.EXTERNAL_EMPLOYEES}
        ></campus-component-eventlist>
        <cr-flex space="md">
          <cr-h2> CHANCENcorner </cr-h2>
          <cr-text> Hier befinden sich Lektionen und Dateien für Externe. </cr-text>
        </cr-flex>

        <campus-component-sticky-search-bar
          @search-text-changed=${(e: ValueEvent<string>) => {
            if (this._userSearchText.value === e.detail.value) return;
            this._userSearchText.next(e.detail.value);
          }}
        >
        </campus-component-sticky-search-bar>

        <cr-flex space="md">
          ${guard(
            [this._userCheckedSubjects.value, this._userSearchText.value, this._updateList],
            () => html`
              <campus-component-section-lesson-list
                ${css({ margin: this.spacing.md })}
                .showSearchBar=${false}
                .mode=${'play'}
                .userCheckedSubjects=${this._userCheckedSubjects.value}
                .userSearchText=${this._userSearchText.value}
                .area=${CampusArea.EXTERNAL_EMPLOYEES}
              ></campus-component-section-lesson-list>
            `,
          )}
        </cr-flex>
      </cr-flex>
    `;
  }
}
